import { useCallback, useSyncExternalStore } from 'react';
import { Breakpoint, mediaBelow, mediaUp } from '@constants/layout';

/** useSyncExternalStore so the first paint already has the right breakpoint. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export const useBreakpointUp = (key: Breakpoint) => useMediaQuery(mediaUp(key));
export const useBreakpointBelow = (key: Breakpoint) => useMediaQuery(mediaBelow(key));
